/**
 * 浏览器类别检测
 * @return {{url: string, utype: string, utitle: string}}
 * @constructor
 */

export function BrowserType() {
    let browser = {'url': '', 'utype': '', 'utitle': ''};
    let chromeType = navigator.userAgent.toLowerCase();

    try {
        if ("ActiveXObject" in window) {
            browser.url = download_url.ie;
            browser.utype = "ie";
            browser.utitle = "IE";
        } else if (chromeType.indexOf('firefox') > -1) {
            browser.url = download_url.firefox;
            browser.utype = "firefox";
            browser.utitle = "Firefox";
            /**
             * firefox 57+ 判断
             */
            let firefoxVersionString = chromeType.match(/firefox\/+\d{2}/);
            if (firefoxVersionString) {
                let firefoxVersion = parseInt(firefoxVersionString[0].slice(-2));
                if (firefoxVersion >= 57) {
                    browser.url = download_url.firefox57
                }
            }

        } else if (chromeType.indexOf('115browser') > -1) {
            browser.url = download_url['115'];
            browser.utype = "115";
            browser.utitle = "115浏览器";
        } else if (chromeType.indexOf('opera') > -1 || chromeType.indexOf('opr') > -1) {
            browser.url = download_url.opera;
            browser.utype = "opera";
            browser.utitle = "Opera";
        } else if (chromeType.indexOf('safari') > -1 && chromeType.indexOf('chrome') === -1) {
            browser.url = download_url.safari;
            browser.utype = "safari";
            browser.utitle = "Safari";
        } else if (chromeType.indexOf('yabrowser') > -1) {
            browser.url = "http://blog.gwdang.com/?p=7385";
            browser.utype = "yandex";
            browser.utitle = "Yandex";
        } else if (chromeType.indexOf('theworld') > -1) {
            browser.url = download_url.theworld;
            browser.utype = "theworld";
            browser.utitle = "世界之窗";
        } else if (chromeType.indexOf('chrome') > -1) {
            let check360 = checkChromeWeight();
            let checkLiebao = checkLiebao6();
            if (checkLiebao) {
                browser.url = download_url.liebao;
                browser.utype = 'liebao';
                browser.utitle = "猎豹安全";
            } else if (chromeType.indexOf('qqbrowser') > -1) {
                browser.url = download_url.qq;
                browser.utype = "qq";
                browser.utitle = "QQ";
            } else if (chromeType.indexOf('maxthon') > -1) {
                browser.url = download_url.maxthon;
                browser.utype = "maxthon";
                browser.utitle = "Maxthon";
            } else if (chromeType.indexOf('bidubrowser') > -1) {
                //mozilla/5.0 (compatible; msie 10.0; windows nt 6.1; wow64; trident/6.0; bidubrowser 8.1)
                browser.url = download_url.baidu
                browser.utype = 'baidu';
                browser.utitle = '百度';
            } else if (chromeType.indexOf('ubrowser') > -1) {
                browser.url = download_url.uc;
                browser.utype = 'uc';
                browser.utitle = "UC";
            } else if (chromeType.indexOf('lbbrowser') > -1) {
                browser.url = download_url.liebao;
                browser.utype = 'liebao';
                browser.utitle = "猎豹安全";
            } else if (chromeType.indexOf('qiyu') > -1) {
                browser.url = download_url.qiyu;
                browser.utype = 'qiyu';
                browser.utitle = "旗鱼";
            } else if (chromeType.indexOf('taobrowser') > -1) {
                browser.url = download_url.taobao;
                browser.utype = 'taobao';
                browser.utitle = "淘宝";
            } else if (chromeType.indexOf('2345explorer') > -1) {
                browser.url = download_url.wp2345;
                browser.utype = 'wp2345';
                browser.utitle = "2345王牌";
            } else if (chromeType.indexOf('2345chrome') > -1) {
                browser.url = download_url.js2345;
                browser.utype = 'js2345';
                browser.utitle = "2345加速";
            } else if (chromeType.indexOf('coolnovo') > -1) {
                //Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/27.0.1453.110 Safari/537.36 CoolNovo/2.0.9.20
                browser.url = download_url.fengshu;
                browser.utype = 'fengshu';
                browser.utitle = "枫树";
            } else if (chromeType.indexOf('greenbrowser') > -1) {
                //Mozilla/4.0 (compatible; MSIE 7.0; Windows NT 6.1; WOW64; Trident/6.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; .NET4.0C; InfoPath.3; .NET4.0E; GreenBrowser)
                browser.url = download_url.gb;
                browser.utype = 'gb';
                browser.utitle = "GB";
            } else if (chromeType.indexOf('edg') > -1) {
                //Mozilla/5.0 (Windows NT 6.1; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.3999.0 Safari/537.36 Edg/81.0.370.0
                //Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/64.0.3282.140 Safari/537.36 Edge/17.17134
                browser.url = download_url.edge;
                browser.utype = 'edge';
                browser.utitle = "Edge";
            } else if (check360 === "Chrome") {
                //mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/46.0.2490.80 safari/537.36
                browser.url = download_url.chrome;
                browser.utype = 'chrome';
                browser.utitle = 'Chrome';
            } else if (check360 === "360SE") {
                //mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/31.0.1650.63 safari/537.36
                browser.url = download_url.se360;
                browser.utype = '360se';
                browser.utitle = '360安全';
            } else if (check360 === "360EE") {
                //mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/45.0.2454.101 safari/537.36
                browser.url = download_url.ee360;
                browser.utype = '360ee';
                browser.utitle = '360极速 ';
            } else if (chromeType.indexOf('se') > -1) {
                //mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/38.0.2125.122 safari/537.36 se 2.x metasr 1.0
                browser.url = download_url.sogou;
                browser.utype = 'sogou';
                browser.utitle = "搜狗";
            } else {
                browser.url = download_url.chrome;
                browser.utype = 'chrome';
                browser.utitle = 'Chromium内核';
            }
        } else {
            browser.url = download_url.chrome;
            browser.utype = 'chrome';
            browser.utitle = '未知浏览器';
        }
    } catch(err) {
        console.log(err)
    }

    return browser;
}

//Chrome、360判断
function checkChromeWeight() {
    let chrome_weight = {
        "result": "Chrome",
        "details": {
            "Chrome": 5,
            "Chromium": 0,
            "_360SE": 0,
            "_360EE": 0
        },
        "sorted": ["Chrome", "360SE", "360EE", "Chromium"],
        "exec": function (results) {
            let details = {
                "Chrome": 5,
                "Chromium": 0,
                "_360SE": 0,
                "_360EE": 0
            }
            let _ua = window.navigator.userAgent;
            if ((/Chrome\/([\d.])+\sSafari\/([\d.])+$/).test(_ua)) {
                if (window.navigator.platform === "Win32") {
                    if (!window.clientInformation.languages) {
                        details._360SE += 8;
                    }
                    if ((/zh/i).test(navigator.language)) {
                        details._360SE += 3;
                        details._360EE += 3;
                    }
                    if (window.clientInformation.languages) {
                        let lang_len = window.clientInformation.languages.length;
                        if (lang_len >= 3) {
                            details.Chrome += 10;
                            details.Chromium += 6;
                        } else if (lang_len === 2) {
                            details.Chrome += 3;
                            details.Chromium += 6;
                            details._360EE += 6;
                        } else if (lang_len === 1) {
                            details.Chrome += 4;
                            details.Chromium += 4;
                        }
                    }
                    for (let i in window.navigator.plugins) {
                        if (window.navigator.plugins[i].filename === "np-mswmp.dll") {
                            details._360SE += 20;
                            details._360EE += 20;
                            break;
                        }
                    }

                    for (let i in window.navigator.mimeTypes) {
                        if (window.navigator.mimeTypes[i]['type'] === 'application/x-shockwave-flash') {
                            details._360SE += 20;
                            details._360EE += 20;
                            break;
                        }
                    }

                    if (window.chrome.webstore) {
                        if (Object.keys(window.chrome.webstore).length <= 1) {
                            details._360SE += 7;
                        } else if (Object.keys(window.chrome.webstore).length === 2) {
                            details._360SE += 4;
                            details.Chromium += 3;
                        }
                    }

                    if (window.navigator.plugins.length >= 30) {
                        details._360EE += 7;
                        details._360SE += 7;
                        details.Chrome += 7;
                    } else if (window.navigator.plugins.length < 30 && window.navigator.plugins.length > 10) {
                        details._360EE += 3;
                        details._360SE += 3;
                        details.Chrome += 3;
                    } else if (window.navigator.plugins.length <= 10) {
                        details.Chromium += 6;
                    }

                } else {
                    details._360SE -= 50;
                    details._360EE -= 50;
                    if ((/Linux/i).test(window.navigator.userAgent)) {
                        details.Chromium += 5;
                    }

                }
                let found = 0;
                let respdf;
                for (let i in window.navigator.plugins) {
                    if (!!(respdf = (/^(.+) PDF Viewer$/).exec(window.navigator.plugins[i].name))) {
                        if (respdf[1] === "Chrome") {
                            details.Chrome += 6;
                            details._360SE += 6;
                            found = 1;
                            break;
                        }
                        if (respdf[1] === "Chromium") {
                            details.Chromium += 10;
                            details._360EE += 6;
                            found = 1;
                            break;
                        }
                    }
                }
                if (!found) {
                    details.Chromium += 9;
                }

            }
            let chrome_result = {};
            chrome_result['Chrome'] = details.Chrome;
            chrome_result['Chromium'] = details.Chromium;
            chrome_result['360SE'] = details._360SE;
            chrome_result['360EE'] = details._360EE;
            let sortable = [];
            for (let value in chrome_result)
                sortable.push([value, chrome_result[value]])
            sortable.sort(function (a, b) {
                return b[1] - a[1]
            });
            this.sorted = sortable;
            this.details = details;
            this.result = sortable[0][0];
            if (results === "result") {
                return sortable[0][0];
            } else if (results === "details") {
                return chrome_result;
            } else if (results === "sorted") {
                return sortable;
            }
        }
    };

    let _ua = window.navigator.userAgent;
    try {
        chrome_weight.exec();
        if ((/Chrome\/([\d.])+\sSafari\/([\d.])+$/).test(_ua)) {
            return chrome_weight.result;
        }
        else {
        }
    } catch (e) {
        return
    }
}


//检测猎豹浏览器6.0
function checkLiebao6() {
    return typeof window.external.LiebaoBackup_Backup === 'function';
}